const CURRENT_INSTANCE = 'currentInstance';
const CURRENT_TOKEN = 'currentToken';
const USERNAME = 'username';
const FULL_NAME = "fullName";

export {CURRENT_INSTANCE, CURRENT_TOKEN, USERNAME, FULL_NAME};